import {COUNTRY_CONFIG} from "./countries";

const DEFAULT_CONFIG = {
  locale: process.env.REACT_APP_LOCALE || "pl",
  currency: process.env.REACT_APP_CURRENCY || "PLN",
  displayCurrency: process.env.REACT_APP_DISPLAY_CURRENCY || "PLN",
};

export function getRuntimeConfig() {
  const url = new URL(window.location.href);

  // wariant A: ?country=france
  const key = (url.searchParams.get("country") || "").toLowerCase();

  if (key && COUNTRY_CONFIG[key]) return COUNTRY_CONFIG[key];
  return DEFAULT_CONFIG;
}
